module.exports = __webpack_public_path__ + "img/task-8-g.004d779a.png";